module.exports = __webpack_public_path__ + "img/Christopher Horn.1705cd1b.jpg";